import { apiClient } from 'client/core/network/apiClient';
import { ICategory } from 'common/schema/Category';

export const CategoryApi = {
  findCategory: (opts: { id: number }) =>
    apiClient.get<ICategory>(`/categories/${opts.id}`)
};
